/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { setCurrentUniqueProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import QuestionProperties from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionproperties';



/* ========== ~~~~~~~~~~ EMBED QUESTION PROPERTIES : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const selectedContent = !contentStatus.noLiveContents ? contentStatus['contents'][contentStatus['selectedContent']] : false;
    const selectedContentDetail = selectedContent ? (selectedContent.contentType === "story") ? selectedContent.story : selectedContent.questionBased : false;
    return {
        contentId: contentStatus['selectedContent'],
        noLiveContents: contentStatus.noLiveContents,
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        backgroundColor: selectedContentDetail ? selectedContentDetail['backgroundColor'] : null,
        contentType: selectedContent ? selectedContent.contentType : null,
    }
};

const mapDispatchToProps = (dispatch) => ({
    setCurrentUniqueProperty: (contentId, property, value) => dispatch(setCurrentUniqueProperty(contentId, property, value)),
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionProperties);
